class Config {

  constructor() {
    this.env = process.env.NODE_ENV;
    this.apiRoot = null;
    this.appRoot = this.valueOrTestDefault(
      process.env.REACT_APP_FOLKSY_DASHBOARD_APP_ROOT,
      'http://test.com',
    );
    this.apiRoot = this.valueOrTestDefault(
      process.env.REACT_APP_FOLKSY_DASHBOARD_API_ROOT,
      'http://test.api',
    );
    this.gaCode = this.valueOrTestDefault(
      process.env.REACT_APP_FOLKSY_DASHBOARD_GA_CODE,
      'TEST-GA-CODE',
    );
    if (!this.appRoot) throw new Error('appRoot not set in Config');
    if (!this.apiRoot) throw new Error('apiRoot not set in Config');
    if (!this.gaCode) throw new Error('gaCode not set in Config');
  }

  valueOrTestDefault(value, testDefault) {
    return (
      this.env === 'test' ?
        testDefault :
        value
    );
  }

}

export default Config;



// WEBPACK FOOTER //
// ./src/utils/config.js